import Api from '../utils/Api'

class CompanyService {

  loginUser(params) {
    return Api.call('/company/login', 'post', params)
    .then(res => {
      //console.log("res data-------",res.data)
      return res.data
    });
  }

  forgotPassword(params) {
    return Api.call('/company/forgot-password', 'post', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }

  changePassword(params) {
    return Api.call('/company/change-password', 'post', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }

  updatePersonalAttributes(params) {
    return Api.call('/company/update-personal-attributes', 'post', params, false, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }

  updateBusinessAttributes(params) {
    return Api.call('/company/update-business-attributes', 'post', params, false, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }

  updateBankAttributes(params) {
    return Api.call('/company/update-bank-attributes', 'post', params, false, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }

  enableMoipAccount() {
    return Api.call('/company/create-company-moip-account', 'post')
      .then(res => res.data)
      .catch(err => { throw err })
  }

  updateLogo(params) {
    return Api.call('/company/update-company-logo', 'post', params, true)
    .then(res => res.data)
    .catch(err => { throw err })
  }

  uploadImages(params, progress) {
    return Api.call('/company/update-company-images', 'post', params, false, true, progress)
    .then(res => res.data)
    .catch(err => { throw err })
  }

  changeCompanyTags(params) {
    return Api.call('/company/post-tags', 'post', params, null, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }

  getCompanyTags() {
    return Api.call('/company/get-tags', 'get')
      .then(res => res.data)
      .catch(err => { throw err })
  }

  downloadLeads() {
    return Api.call('/company/download-leads', 'get')
      .then(res => res.data)
      .catch(err => { throw err })
  }

  createAccount(params) {
    return Api.call('/company/create-company-account', 'post', params, false, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }

  validateEmail(params) {
    return Api.call('/company/get-company-by-email-token', 'get', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }

  publishAdvertise(params) {
    return Api.call('/company/publish-company-advertise', 'post', params, false, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }

  getCategories() {
    return Api.call('/category/get-categories', 'get', {withNoAdventures: true})
      .then(res => res.data)
      .catch(err => { throw err })
  }

  getTypes() {
    return Api.call('/company/get-categories-types', 'get')
      .then(res => res.data)
      .catch(err => { throw err })
  }

  getRegions() {
    return Api.call('/region/get-all-regions', 'get')
      .then(res => res.data)
      .catch(err => { throw err })
  }
}

export default new CompanyService();


// WEBPACK FOOTER //
// ./src/services/CompanyService.js